// Material types and subcategories data structure based on WARM list
export const materialTypes = [
  {
    type: 'Paper',
    icon: '📄',
    materials: [
      'Corrugated Containers',
      'Magazines/Third-class Mail',
      'Newspaper',
      'Office Paper',
      'Phonebooks',
      'Textbooks',
      'Mixed Paper (general)',
      'Mixed Paper (primarily residential)',
      'Mixed Paper (primarily from offices)'
    ]
  },
 /*{
    type: 'Food Waste',
    icon: '🍎',
    materials: [
    //  'Food Waste',
    //  'Food Waste (non-meat)',
    //  'Food Waste (meat only)',
      'Beef',
      'Poultry',
      'Grains',
      'Bread',
      'Fruits and Vegetables',
      'Dairy Products'
    ]
  },
   {
    type: 'Yard Trimmings',
    icon: '🌿',
    materials: [
      'Yard Trimmings',
      'Grass',
      'Leaves',
      'Branches'
    ]
  },*/
  {
    type: 'Mixed Plastics',
    icon: '♻️',
    materials: [
      'HDPE',
      'LDPE',
      'PET',
      'LLDPE',
      'PP',
      'PS',
      'PVC',
      'Mixed Plastics'
    ]
  },
  {
    type: 'Bioplastics',
    icon: '🌱',
    materials: [
      'PLA'
    ]
  },
  {
    type: 'Electronics',
    icon: '💻',
    materials: [
      'Desktop CPUs',
      'Portable Electronic Devices',
      'Flat-Panel Displays',
      'CRT Displays',
      'Electronic Peripherals',
      'Hard-Copy Devices',
      'Mixed Electronics'
    ]
  },
  {
    type: 'Metals',
    icon: '🔩',
    materials: [
      'Aluminum Cans',
      'Aluminum Ingot',
      'Steel Cans',
      'Copper Wire',
      'Mixed Metals'
    ]
  },
  {
    type: 'Glass',
    icon: '🍶',
    materials: [
      'Glass'
    ]
  },
  {
    type: 'Construction',
    icon: '🏗️',
    materials: [
      'Asphalt Concrete',
      'Asphalt Shingles',
      'Carpet',
      'Clay Bricks',
      'Concrete',
      'Dimensional Lumber*',
      'Drywall',
      'Fiberglass Insulation',
      'Fly Ash',
      'Medium-density Fiberboard',
      'Structural Steel',
      'Vinyl Flooring',
      'Wood Flooring*'
    ]
  },
  {
    type: 'Tires',
    icon: '🛞',
    materials: [
      'Tires'
    ]
  },
  {
    type: 'Mixed',
    icon: '📦',
    materials: [
      'Mixed Recyclables',
      'Mixed Organics',
      'Mixed MSW'
    ]
  }
];
